module.exports = __webpack_public_path__ + "img/example2.ebbae86d.png";